export function inquiryForm() {
    const $formWrapper = $(".inquiry-form-wrapper");
    const $formContactsBlock = $formWrapper.find(".inquiry-form-contacts");
    // const $form = $formWrapper.find(".inquiry-form");
    let formContactCoef = 0;
    let coef = 223;


    $(window).on("load resize", function () {
        $formWrapper.each(function () {
            let $this = $(this);
            let $formContactsBlock = $this.find(".inquiry-form-contacts");
            let $heroSection = $this.parents("section").prev(".hero-section");
            if (window.innerWidth >= 768 && $formContactsBlock.length) {
                formContactCoef = $formContactsBlock.innerHeight();
            } else {
                formContactCoef = 0;
            }
            if ($heroSection.length) {
                let heroHeight = $heroSection.innerHeight();

                $heroSection.next().find(".inquiry-form-wrapper").css({
                    "margin-top": -(heroHeight - coef)
                });
                if (window.innerWidth >= 768) {
                    $heroSection.next().find(".inquiry-form").css({
                        "margin-top": -((heroHeight / 2 + coef) / 2 + formContactCoef)
                    });
                    $heroSection.next().find(".inquiry-form-contacts").css({
                        "margin-top": (heroHeight / 2 + coef) / 2
                    });
                }
            } else {
                $this.find(".inquiry-form").css({
                    "margin-top": -formContactCoef
                });
            }
        });
    });
}





// WEBPACK FOOTER //
// ./assets/js/modules/inquiryForm.js